// extracted by mini-css-extract-plugin
export default {"bottomBanner":"InfoBanner_bottomBanner__b2ntP","content":"InfoBanner_content__iO7tn"};